<template>
    <el-dialog :close-on-click-modal="false"
               :title="titleDialog"
               :visible="showDialog"
               :append-to-body="true"
               @close="close"
               @open="create"
               @opened="opened">
        <form autocomplete="off"
              @submit.prevent="submit">
            <div class="form-body">
                <el-tabs v-model="activeName">
                    <el-tab-pane class
                                 name="first">
                        <span slot="label">{{ titleTabDialog }}</span>
                        <div class="row">
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Tipo Doc. Identidad <span class="text-danger">*</span></label>
                                    <el-select v-model="form.identity_document_type_id"
                                               dusk="identity_document_type_id"
                                               filterable
                                               popper-class="el-select-identity_document_type"
                                               @change="changeIdentityDocType">
                                        <el-option v-for="option in identity_document_types"
                                                   :key="option.id"
                                                   :label="option.description"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <!-- <small v-if="errors.identity_document_type_id"
                                           class="form-control-feedback"
                                           v-text="errors.identity_document_type_id[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Número <span class="text-danger">*</span></label>

                                    <div v-if="api_service_token != false">
                                        <x-input-service v-model="form.number"
                                                         :identity_document_type_id="form.identity_document_type_id"
                                                         @search="searchNumber"></x-input-service>
                                    </div>
                                    <div v-else>
                                        <el-input v-model="form.number"
                                                  :maxlength="maxLength"
                                                  dusk="number">
                                            <template
                                                v-if="form.identity_document_type_id === '6' || form.identity_document_type_id === '1'">
                                                <el-button slot="append"
                                                           :loading="loading_search"
                                                           icon="el-icon-search"
                                                           type="primary"
                                                           @click.prevent="searchCustomer">
                                                    <template v-if="form.identity_document_type_id === '6'">
                                                        SUNAT
                                                    </template>
                                                    <template v-if="form.identity_document_type_id === '1'">
                                                        RENIEC
                                                    </template>
                                                </el-button>
                                            </template>
                                        </el-input>
                                    </div>

                                    <!-- <small v-if="errors.number"
                                           class="form-control-feedback"
                                           v-text="errors.number[0]"></small> -->
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-9">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Nombre <span class="text-danger">*</span></label>
                                    <el-input v-model="form.name"
                                              dusk="name"></el-input>
                                    <!-- <small v-if="errors.name"
                                           class="form-control-feedback"
                                           v-text="errors.name[0]"></small> -->
                                </div>
                            </div>
                            
                        </div>

                        <!-- <div class="row" v-if="type === 'customers'">
                            <div class="col-md-4">
                                <div class="form-group" :class="{'has-danger': errors.person_type_id}">
                                    <label class="control-label">Tipo de cliente</label>
                                    <el-select v-model="form.person_type_id" filterable  >
                                        <el-option v-for="option in person_types" :key="option.id" :value="option.id" :label="option.description"></el-option>
                                    </el-select>
                                    <small class="form-control-feedback" v-if="errors.person_type_id" v-text="errors.person_type_id[0]"></small>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="form-group"  >
                                    <label class="control-label">Comentario</label>
                                    <el-input v-model="form.comment"></el-input>
                                </div>
                            </div>
                        </div> -->

                        <div class="row">
                            <div class="col-12">
                                <label class="control-label">
                                    Dirección principal
                                </label>
                            </div>
                            <div class="col-md-3">
                                <div 
                                        class="form-group">
                                    <label class="control-label">País</label>
                                    <el-select v-model="form.country_id"
                                                dusk="country_id"
                                                filterable>
                                        <el-option v-for="option in countries"
                                                    :key="option.id"
                                                    :label="option.description"
                                                    :value="option.id"></el-option>
                                    </el-select>
                                    <!-- <small v-if="errors.country_id"
                                            class="form-control-feedback"
                                            v-text="errors.country_id[0]"></small> -->
                                </div>
                            </div>

                            <div class="col-md-9">
                                <div 
                                        class="form-group">
                                    <label class="control-label">Ubigeo</label>
                                    <el-cascader v-model="form.location_id"
                                                    :clearable="true"
                                                    :options="locations"
                                                    filterable></el-cascader>
                                    <!-- <small v-if="errors.location_id"
                                            class="form-control-feedback"
                                            v-text="errors.location_id[0]"></small> -->
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Dirección</label>
                                    <el-input v-model="form.address"
                                              dusk="address"></el-input>
                                    <!-- <small v-if="errors.address"
                                           class="form-control-feedback"
                                           v-text="errors.address[0]"></small> -->
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="form.state"
                                    class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Estado del Contribuyente</label>
                                    <template v-if="form.state == 'ACTIVO'">
                                        <el-alert :closable="false"
                                                    :title="`${form.state}`"
                                                    show-icon
                                                    type="success"></el-alert>
                                    </template>
                                    <template v-else>
                                        <el-alert :closable="false"
                                                    :title="`${form.state}`"
                                                    show-icon
                                                    type="error"></el-alert>
                                    </template>
                                </div>
    
                            </div>
                            <div v-if="form.condition"
                                    class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Condición del Contribuyente</label>
                                    <template v-if="form.condition == 'HABIDO'">
                                        <el-alert :closable="false"
                                                    :title="`${form.condition}`"
                                                    show-icon
                                                    type="success"></el-alert>
                                    </template>
                                    <template v-else>
                                        <el-alert :closable="false"
                                                    :title="`${form.condition}`"
                                                    show-icon
                                                    type="error"></el-alert>
                                    </template>
                                </div>
    
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12">
                                <label @click="showMoreInformation = !showMoreInformation" style="cursor: pointer;"
                                    class="font-weight-bold"
                                >
                                    <i class="fa fa-plus text-info"></i>
                                        {{ showMoreInformation ? 'Ocultar' : 'Mostrar' }} Información Adicional
                                </label>
                            </div>
                        </div>

                        <template v-if="showMoreInformation">
                            <div class="row">
                                <div class="col-md-6">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Código de establecimiento</label>
                                        <el-input v-model="form.establishment_code"
                                                dusk="establishment_code"></el-input>
                                        <!-- <small v-if="errors.establishment_code"
                                            class="form-control-feedback"
                                            v-text="errors.establishment_code[0]"></small> -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div 
                                            class="form-group">
                                        <label class="control-label">Teléfono</label>
                                        <el-input v-model="form.telephone"
                                                    dusk="telephone"></el-input>
                                        <!-- <small v-if="errors.telephone"
                                                class="form-control-feedback"
                                                v-text="errors.telephone[0]"></small> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Correo electrónico</label>
                                        <el-input v-model="form.email"
                                                dusk="email"></el-input>
                                        <!-- <small v-if="errors.email"
                                            class="form-control-feedback"
                                            v-text="errors.email[0]"></small> -->
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div
                                        class="form-group">
                                        <label class="control-label">Correos opcionales </label>
                                        <el-input

                                            v-model="temp_email"
                                            dusk="email"
                                            @change="checkEmail()"
                                        >

                                        </el-input>


                                        <el-button
                                            v-if="temp_email != null && temp_email.length > 1 && checkEmail() == true"
                                            icon="el-icon-plus"
                                            size="mini"
                                            @click.prevent="clickAddMail()">
                                            Agregar Correo
                                        </el-button>

                                        <label v-if="form.optional_email !== undefined &&
                                        form.optional_email.length > 0"
                                            class="control-label">
                                            <el-tag
                                                v-for="mail in form.optional_email"
                                                :key="mail.email"
                                                :closable="true"
                                                :type="'success'"
                                                @close="removeEmail(mail)"
                                            >
                                                {{ mail.email }}
                                            </el-tag>

                                        </label>
                                        <!-- <small v-if="errors.temp_email && errors.temp_email.length > 0"
                                            class="form-control-feedback"
                                            v-text="errors.temp_email"></small>


                                        <small v-if="errors.email"
                                            class="form-control-feedback"
                                            v-text="errors.email[0]"></small> -->
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-9">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Nombre comercial</label>
                                        <el-input v-model="form.trade_name"
                                                dusk="trade_name"></el-input>
                                        <!-- <small v-if="errors.trade_name"
                                            class="form-control-feedback"
                                            v-text="errors.trade_name[0]"></small> -->
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Dias de crédito</label>
                                        <el-input-number
                                            v-model="form.credit_days"
                                            :controls="false"
                                            :min="0"
                                            :precision="0"></el-input-number>
                                        <!-- <small v-if="errors.credit_days"
                                            class="form-control-feedback"
                                            v-text="errors.credit_days[0]"></small> -->
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                
                                <div class="col-md-3">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Código interno</label>
                                        <el-input v-model="form.internal_code"></el-input>
                                        <!-- <small v-if="errors.internal_code"
                                            class="form-control-feedback"
                                            v-text="errors.internal_code[0]"></small> -->
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Nacionalidad</label>
                                        <el-select v-model="form.nationality_id"
                                                dusk="country_id"
                                                filterable>
                                            <el-option v-for="option in countries"
                                                    :key="option.id"
                                                    :label="option.description"
                                                    :value="option.id"></el-option>
                                        </el-select>
                                        <!-- <small v-if="errors.country_id"
                                            class="form-control-feedback"
                                            v-text="errors.country_id[0]"></small> -->
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">
                                            {{ typeDialog }}
                                        </label>
                                        <el-select v-model="form.person_type_id"
                                                clearable
                                                filterable>
                                            <el-option v-for="option in person_types"
                                                    :key="option.id"
                                                    :label="option.description"
                                                    :value="option.id"></el-option>
                                        </el-select>
                                        <!-- <small v-if="errors.person_type_id"
                                            class="form-control-feedback"
                                            v-text="errors.person_type_id[0]"></small> -->
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Código de barra</label>
                                        <el-input v-model="form.barcode"></el-input>
                                        <!-- <small v-if="errors.barcode"
                                            class="form-control-feedback"
                                            v-text="errors.barcode[0]"></small> -->
                                    </div>
                                </div>

                                <div v-if="showAccumulatedPoints"
                                    class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Sistema de puntos
                                        </label>
                                        <el-input v-model="form.accumulated_points"></el-input>
                                        <small v-if="errors.accumulated_points"
                                            class="form-control-feedback"
                                            v-text="errors.accumulated_points[0]"></small>
                                    </div>
                                </div>
                            </div>
                            <div v-if="type === 'suppliers'"
                             class="row mt-2">
                            <div class="col-md-6 center-el-checkbox">
                                <div 
                                     class="form-group">
                                    <el-checkbox v-model="form.perception_agent">¿Es agente de percepción?</el-checkbox>
                                    <br>
                                    <!-- <small v-if="errors.perception_agent"
                                           class="form-control-feedback"
                                           v-text="errors.perception_agent[0]"></small> -->
                                </div>
                            </div>
                            <div v-if="type === 'suppliers'"
                                    v-show="form.perception_agent"
                                    class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Porcentaje de percepción</label>

                                        <el-input v-model="form.percentage_perception"></el-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2" v-if="config.enable_discount_by_customer">
                                <div class="col-lg-4 col-md-4">
                                    <label class="control-label">
                                        ¿Tiene descuento?
                                    </label>
                                    <div 
                                        class="form-group mt-1">
                                        <el-switch v-model="form.has_discount"
                                                active-text="Si"
                                                inactive-text="No"></el-switch>
                                        <!-- <small v-if="errors.has_discount"
                                            class="form-control-feedback"
                                            v-text="errors.has_discount[0]"></small> -->
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">
                                            Tipo de descuento
                                        </label>
                                        <el-select v-model="form.discount_type">
                                            <el-option v-for="option in discount_types"
                                                    :key="option.id"
                                                    :label="option.name"
                                                    :value="option.id">{{ option.name }}
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4">
                                    <div 
                                        class="form-group">
                                        <label class="control-label">Descuento ({{ (form.discount_type === '01')?'Monto':'Porcentaje' }})</label>
                                        <el-input v-model="form.discount_amount"></el-input>
                                        <!-- <small v-if="errors.discount_amount"
                                            class="form-control-feedback"
                                            v-text="errors.discount_amount[0]"></small> -->
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-tab-pane>

                    <el-tab-pane class
                                 name="second">
                        <span slot="label">Dirección Secundaria</span>
                        <div class="row m-t-10">
                            <div class="col-md-12 text-center">
                                <el-button icon="el-icon-plus"
                                           size="mini"
                                           @click.prevent="clickAddAddress()">
                                    Agregar dirección
                                </el-button>
                            </div>
                        </div>
                        <div v-for="(row, index) in form.secondary_addresses"
                             :key="index"
                             class="row m-t-10">
                            <div class="col-md-12">
                                <!-- <label v-if="index === 0"
                                       class="control-label">
                                    Dirección principal
                                </label>
                                <label v-else
                                       class="control-label">
                                    Dirección secundaria # {{ index }}
                                    <el-button class="btn-default-danger"
                                               icon="el-icon-minus"
                                               size="mini"
                                               @click.prevent="clickRemoveAddress(index)">Eliminar dirección
                                    </el-button>
                                </label> -->

                                <label class="control-label">
                                    Dirección secundaria # {{ index + 1 }}
                                    <el-button class="btn-default-danger"
                                               icon="el-icon-minus"
                                               size="mini"
                                               @click.prevent="clickRemoveAddress(index)">Eliminar dirección
                                    </el-button>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <div 
                                     class="form-group">
                                    <label class="control-label">País</label>
                                    <el-select v-model="row.country_id"
                                               filterable>
                                        <el-option v-for="option in countries"
                                                   :key="option.id"
                                                   :label="option.description"
                                                   :value="option.id"></el-option>
                                    </el-select>
                                    <!-- <small v-if="errors.country_id"
                                           class="form-control-feedback"
                                           v-text="errors.country_id[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Ubigeo</label>
                                    <el-cascader v-model="row.location_id"
                                                 :clearable="true"
                                                 :options="locations"
                                                 filterable></el-cascader>
                                    <!-- <small v-if="errors.location_id"
                                           class="form-control-feedback"
                                           v-text="errors.location_id[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Dirección</label>
                                    <el-input v-model="row.address"></el-input>
                                    <!-- <small v-if="errors.address"
                                           class="form-control-feedback"
                                           v-text="errors.address[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Código de establecimiento</label>
                                    <el-input v-model="row.establishment_code"></el-input>
                                    <!-- <small v-if="errors.establishment_code"
                                           class="form-control-feedback"
                                           v-text="errors.establishment_code[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Teléfono</label>
                                    <el-input v-model="row.phone"></el-input>
                                    <!-- <small v-if="errors.phone"
                                           class="form-control-feedback"
                                           v-text="errors.phone[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Correo electrónico</label>
                                    <el-input v-model="row.email"></el-input>
                                    <!-- <small v-if="errors.email"
                                           class="form-control-feedback"
                                           v-text="errors.email[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Correos opcionales</label>
                                    <el-input
    
                                        v-model="row.mail_input"
                                        dusk="email"
                                        @change="checkEmailSecondary(row)"
                                    >
    
                                    </el-input>
    
    
                                    <el-button
                                        v-if="row.mail_input && checkEmailSecondary(row)"
                                        icon="el-icon-plus"
                                        size="mini"
                                        @click.prevent="clickAddMailSecondary(row)">
                                        Agregar Correo
                                    </el-button>
    
                                    <label v-if="row.optional_email"
                                            class="control-label">
                                        <el-tag
                                            v-for="mail in row.optional_email"
                                            :key="mail.email"
                                            :closable="true"
                                            :type="'success'"
                                            @close="removeEmailSecondary(row, mail)"
                                        >
                                            {{ mail.email }}
                                        </el-tag>
    
                                    </label>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane class
                                 name="third">
                        <span slot="label">Otros Datos</span>
                        <div class="row ">
                            <div class="col-12">
                                <h4>Contacto</h4>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Nombre y Apellido</label>
                                    <el-input v-model="form.contact.full_name"></el-input>
                                    <!-- <small v-if="errors.contact"
                                           class="form-control-feedback"
                                           v-text="errors.contact[0]"></small> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Teléfono</label>
                                    <el-input v-model="form.contact.phone"></el-input>
                                    <!-- <small v-if="errors.contact"
                                           class="form-control-feedback"
                                           v-text="errors.contact[0]"></small> -->
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <!--SitioWeb -->
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Sitio Web</label>
                                    <el-input v-model="form.website"></el-input>
                                    <!-- <small v-if="errors.website"
                                           class="form-control-feedback"
                                           v-text="errors.website[0]"></small> -->
                                </div>
                            </div>
                            <!--Observaciones -->
                            <div class="col-md-6">
                                <div 
                                     class="form-group">
                                    <label class="control-label">Observaciones</label>
                                    <el-input v-model="form.observation"></el-input>
                                    <!-- <small v-if="errors.observation"
                                           class="form-control-feedback"
                                           v-text="errors.observation[0]"></small> -->
                                </div>
                            </div>
                            <!--ID Días Crédito -->

                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4">

                                <div 
                                     class="form-group">
                                    <label class="control-label">
                                        Vendedor
                                    </label>
                                    <el-select v-model="form.seller_id"
                                               clearable>
                                        <el-option v-for="option in sellers"
                                                   :key="option.id"
                                                   :label="option.name"
                                                   :value="option.id">{{ option.name }}
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div 
                                     class="form-group">
                                    <label class="control-label">
                                        Zona
                                    </label>

                                    <a v-if="form_zone.add == false"
                                       class="control-label font-weight-bold text-info"
                                       href="#"
                                       @click="form_zone.add = true"> [ + Nuevo]</a>
                                    <a v-if="form_zone.add == true"
                                       class="control-label font-weight-bold text-info"
                                       href="#"
                                       @click="saveZone()"> [ + Guardar]</a>
                                    <a v-if="form_zone.add == true"
                                       class="control-label font-weight-bold text-danger"
                                       href="#"
                                       @click="form_zone.add = false"> [ Cancelar]</a>
                                    <el-input v-if="form_zone.add == true"
                                              v-model="form_zone.name"
                                              dusk="item_code"
                                              style="margin-bottom:1.5%;"></el-input>

                                    <el-select v-if="form_zone.add == false"
                                               v-model="form.zone_id"
                                               clearable
                                               filterable>
                                        <el-option v-for="option in arrayZones"
                                                   :key="option.id"
                                                   :label="option.name"
                                                   :value="option.id"
                                                   :disabled="!option.active"
                                                   ></el-option>
                                    </el-select>
                                    <!-- <small v-if="errors.zone_id"
                                           class="form-control-feedback"
                                           v-text="errors.zone_id[0]"></small> -->
                                </div>
                            </div>


                            <!--Zona -->
                            <!--
                            <div class="col-md-6">
                                <div :class="{'has-danger': errors.zone }"
                                     class="form-group">
                                    <label class="control-label">Zona</label>
                                    <el-input v-model="form.zone"></el-input>
                                    <small v-if="errors.zone"
                                           class="form-control-feedback"
                                           v-text="errors.zone[0]"></small>
                                </div>
                            </div>
                            -->
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="form-actions text-right mt-4">
                <el-button @click.prevent="close()">Cancelar</el-button>
                <el-button :loading="loading_submit"
                           native-type="submit"
                           type="primary">Guardar
                </el-button>
            </div>
        </form>
    </el-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex/dist/vuex.mjs";

import {serviceNumber} from '../../../mixins/functions'

export default {
    mixins: [serviceNumber],
    props: [
        'showDialog',
        'type',
        'recordId',
        'external',
        'document_type_id',
        'input_person',
        'parentId',
        'is_dispatch',
        'showAccumulatedPoints'
    ],
    data() {
        return {
            form_zone: {add: false, name: null, id: null},
            parent: null,
            loading_submit: false,
            titleDialog: null,
            titleTabDialog: null,
            typeDialog: null,
            resource: 'persons',
            errors: {},
            api_service_token: false,
            form: {
                optional_email: [],
                secondary_addresses: [],
            },
            temp_optional_email: [],
            temp_email: null,
            countries: [],
            zones: [],
            sellers: [],
            all_departments: [],
            all_provinces: [],
            all_districts: [],
            provinces: [],
            districts: [],
            locations: [],
            person_types: [],
            identity_document_types: [],
            discount_types: [],
            activeName: 'first',
            errores: [],
            showMoreInformation: false
        }
    },
    async created() {

        this.loadConfiguration()
        await this.initForm()
        await this.$http.get(`/${this.resource}/tables`)
            .then(response => {
                this.api_service_token = response.data.api_service_token
                // console.log(this.api_service_token)

                this.countries = response.data.countries
                this.zones = response.data.zones
                this.sellers = response.data.sellers
                this.all_departments = response.data.departments;
                this.all_provinces = response.data.provinces;
                this.all_districts = response.data.districts;
                this.identity_document_types = response.data.identity_document_types;
                this.locations = response.data.locations;
                this.person_types = response.data.person_types;
                this.discount_types = response.data.discount_types;
            })
            .finally(() => {
                if (this.api_service_token === false) {
                    if (this.config.api_service_token !== undefined) {
                        this.api_service_token = this.config.api_service_token
                    }
                }
            })

    },
    computed: {
        ...mapState([
            'config',
            'person',
            'parentPerson',
        ]),
        maxLength: function () {
            if (this.form.identity_document_type_id === '6') {
                return 11
            }
            if (this.form.identity_document_type_id === '1') {
                return 8
            }
        },
        arrayZones() {
            let zones = this.zones.filter(zone => zone.active)
            if (this.recordId) {
                const zoneSelected = this.zones.filter(zone => zone.id === this.form.zone_id)
                if (zoneSelected.length) {
                    zones.push(zoneSelected[0])
                }
            }
            const seen = new Set()
            return zones.filter(zone => (seen.has(zone.id) ? false : (seen.add(zone.id), true)))
        }
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                type: this.type,
                credit_days: 0,
                identity_document_type_id: '6',
                number: '',
                name: null,
                trade_name: null,
                country_id: 'PE',
                nationality_id: 'PE',
                location_id: [],
                // department_id: null,
                // province_id: null,
                // district_id: null,
                address: null,
                telephone: null,
                condition: null,
                state: null,
                email: null,
                perception_agent: false,
                percentage_perception: 0,
                person_type_id: null,
                comment: null,
                addresses: [],
                secondary_addresses: [],
                contact: {
                    full_name: null,
                    phone: null,
                },
                optional_email: [],
                has_discount: false,
                discount_type: '01',
                discount_amount: 0,
                establishment_code:'0000',
                accumulated_points: 0
            }
            // this.updateEmail()

        },
        async opened() {

            if (this.external && this.input_person) {
                if (this.form.number.length === 8 || this.form.number.length === 11) {
                    if (this.api_service_token != false) {
                        await this.$eventHub.$emit('enableClickSearch')
                    } else {
                        this.searchCustomer()
                    }
                }
            }

        },
        create() {
            // console.log(this.input_person)
            this.initForm()
            this.activeName = 'first'
            this.showMoreInformation = false
            this.parent = 0;
            if (this.parentId !== undefined) {
                this.parent = this.parentId;
            }
            /*

            'person',
            'parentPerson',
            */
            if (this.external) {
                if (this.document_type_id === '01') {
                    this.form.identity_document_type_id = '6'
                }
                if (this.document_type_id === '03') {
                    this.form.identity_document_type_id = '1'
                }

                if (this.input_person) {
                    this.form.identity_document_type_id = (this.input_person.identity_document_type_id) ? this.input_person.identity_document_type_id : this.form.identity_document_type_id
                    this.form.number = (this.input_person.number) ? this.input_person.number : ''
                }
            }
            if (this.type === 'customers') {
                this.titleDialog = (this.recordId) ? 'Editar Cliente' : 'Nuevo Cliente'
                this.titleTabDialog = 'Datos de Cliente';
                this.typeDialog = 'Tipo de cliente'
            }
            if (this.type === 'suppliers') {
                this.titleDialog = (this.recordId) ? 'Editar Proveedor' : 'Nuevo Proveedor'
                this.titleTabDialog = 'Datos del proveedor';
                this.typeDialog = 'Tipo de proveedor'
            }

            if (this.recordId) {
                this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        console.log(response.data.data)
                        // this.form = response.data.data
                        this.form = {
                            ...this.form,
                            ...response.data.data,
                        }
                        
                        if (response.data.data.contact == null) {
                            this.form.contact = {
                                full_name: null,
                                phone: null,
                            }
                        }

                        const addresses = response.data.data.addresses || []
                        this.form.addresses = []
                        addresses.forEach((address, index) => {
                            if (address.main) {
                                this.form.country_id = address.country_id
                                this.form.location_id = address.location_id
                                this.form.address = address.address
                                this.form.establishment_code = address.establishment_code
                                this.form.telephone = address.phone
                                this.form.email = address.email
                                // this.temp_optional_email = address.optional_email || []
                                this.form.optional_email = address.optional_email || []
                                this.form.addresses.push({
                                    id: address.id,
                                    country_id: address.country_id,
                                    location_id: address.location_id,
                                    address: address.address,
                                    email: address.email,
                                    phone: address.phone,
                                    main: address.main,
                                    establishment_code: address.establishment_code,
                                    optional_email: address.optional_email || [],
                                })
                            } else {
                                this.form.secondary_addresses = this.form.secondary_addresses || []
                                this.form.secondary_addresses.push({
                                    id: address.id,
                                    country_id: address.country_id,
                                    location_id: address.location_id,
                                    address: address.address,
                                    email: address.email,
                                    phone: address.phone,
                                    main: false,
                                    establishment_code: address.establishment_code,
                                    optional_email: address.optional_email || [],
                                    mail_input: null
                                })
                            }
                        })

                        if (!this.form.addresses.length) {
                            this.form.country_id = 'PE'
                            this.form.establishment_code = '0000'
                        }

                        this.filterProvinces()
                        this.filterDistricts()
                    }).then(() => {
                    // this.updateEmail()

                })
            }
        },
        clickAddAddress() {
            /* this.form.more_address.push({
                 location_id: [],
                 address: null,
             })*/

            // this.form.addresses
            this.form.secondary_addresses.push({
                'id': null,
                'country_id': 'PE',
                'location_id': [],
                'address': null,
                'email': null,
                'phone': null,
                'main': false,
                'establishment_code':'0000',
                'optional_email': [],
                'mail_input': null
            });
        },
        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        updateEmail() {
            this.temp_optional_email = this.form.optional_email;

        },
        removeEmail(email) {
            if (this.form.optional_email === undefined) this.form.optional_email = []
            this.form.optional_email = this.form.optional_email.filter(function (item) {
                return item.email !== email.email;
            });

            // this.updateEmail()

        },
        checkEmail() {
            this.errors.temp_email = null;
            if (this.temp_email === null) {
                return false;
            }
            if (this.temp_email === undefined) {
                return false;
            }
            let email = this.temp_email;

            if (this.validateEmail(email)) {
                if (this.form.optional_email !== undefined) {
                    let tem = _.find(this.form.optional_email, {'email': email});
                    if (tem === undefined) {
                        return true;
                    } else {
                        // this.errors.temp_email = "Correo ya registrado"
                    }
                }
            } else {
                // this.errors.temp_email = "No es un correo valido"
            }
            return false;

        },
        clickAddMail() {
            if (this.form.optional_email === undefined) this.form.optional_email = []
            if (this.checkEmail() === true) {
                let email = this.temp_email;
                this.form.optional_email.push(
                    {email: email,}
                )
                // this.updateEmail()
                this.temp_email = null;
            }

        },
        checkEmailSecondary({ mail_input }) {
            if (!mail_input) return false
            if (this.validateEmail(mail_input)) {
                return true
            }
            return false
        },
        clickAddMailSecondary(row) {
            if (this.checkEmailSecondary(row)) {
                const { mail_input } = row
                if (this.validateEmail(mail_input)) {
                    const exists = row.optional_email.find(mail => mail.email === mail_input)
                    if (!exists) {
                        row.optional_email.push({
                            email: mail_input
                        })
                    }
                }
                row.mail_input = null
            }
        },
        removeEmailSecondary(row, { email }) {
            row.optional_email = row.optional_email.filter(mail => mail.email !== email)
        },
        validateDigits() {

            const pattern_number = new RegExp('^[0-9]+$', 'i');

            if (this.form.identity_document_type_id === '6') {

                if (this.form.number.length !== 11) {
                    return {
                        success: false,
                        message: `El campo número debe tener 11 dígitos.`
                    }
                }

                if (!pattern_number.test(this.form.number)) {
                    return {
                        success: false,
                        message: `El campo número debe contener solo números`
                    }
                }

            }


            if (this.form.identity_document_type_id === '1') {

                if (this.form.number.length !== 8) {
                    return {
                        success: false,
                        message: `El campo número debe tener 8 dígitos.`
                    }
                }

                if (!pattern_number.test(this.form.number)) {
                    return {
                        success: false,
                        message: `El campo número debe contener solo números`
                    }
                }
            }


            if (['4', '7', '0'].includes(this.form.identity_document_type_id)) {

                const pattern = new RegExp('^[A-Z0-9\-]+$', 'i');

                if (!pattern.test(this.form.number)) {
                    return {
                        success: false,
                        message: `El campo número no cumple con el formato establecido`
                    }
                }

            }


            return {
                success: true
            }
        },
        async submit() {

            let val_digits = await this.validateDigits()
            if (!val_digits.success) {
                return this.$message.error(val_digits.message)
            }

            if (!this.config.enable_discount_by_customer) {
                this.form.has_discount = false;
            }

            if (!this.form.has_discount) {
                this.form.discount_type = '01';
                this.form.discount_amount = 0;
            }

            if (this.is_dispatch) {
               if (this.form.location_id.length !== 3 || !this.form.address) {
                    return this.$message.error('Falta agregar Ubigeo o dirección');
               } 
            }

            if (this.form.address && (this.form.location_id.length!==3)) {
                    return this.$message.error('Falta registrar el ubigeo');
            }

            // if(this.form.location_id.length===3 && this.form.identity_document_type_id === '6'){
            //     if(!this.form.address){
            //         return this.$message.error('Se debe ingresar dirección');
            //     }
            // }

            if (!this.recordId) {
                // if(this.form.addresses.length==0 && this.form.location_id.length===3 && this.form.address!=null ){
                //     this.form.addresses.push({
                //         'id': null,
                //         'country_id': 'PE',
                //         'location_id': this.form.location_id,
                //         'address': this.form.address,
                //         'email': this.form.email,
                //         'phone': this.form.telephone,
                //         'main': true,
                //         'establishment_code':this.form.establishment_code,
                //         'optional_email': this.form.optional_email
                //     });
                // }
                this.form.addresses.push({
                    'id': null,
                    'country_id': 'PE',
                    'location_id': this.form.location_id,
                    'address': this.form.address,
                    'email': this.form.email,
                    'phone': this.form.telephone,
                    'main': true,
                    'establishment_code':this.form.establishment_code,
                    'optional_email': this.form.optional_email
                })
            } else {
                if (this.form.addresses.length) {
                    const index = this.form.addresses.findIndex(address => address.main)
                    if (index !== -1) {
                        this.form.addresses[index].country_id = this.form.country_id
                        this.form.addresses[index].location_id = this.form.location_id
                        this.form.addresses[index].address = this.form.address
                        this.form.addresses[index].email = this.form.email
                        this.form.addresses[index].phone = this.form.telephone
                        this.form.addresses[index].establishment_code = this.form.establishment_code
                        this.form.addresses[index].optional_email = this.form.optional_email
                    }
                } else {
                    // if (this.form.location_id.length === 3 && this.form.address != null) {
                        this.form.addresses.push({
                            'id': null,
                            'country_id': 'PE',
                            'location_id': this.form.location_id,
                            'address': this.form.address,
                            'email': this.form.email,
                            'phone': this.form.telephone,
                            'main': true,
                            'establishment_code':this.form.establishment_code,
                            'optional_email': this.form.optional_email,
                        })
                    // }
                }
            }

            this.form.optional_email = null

            this.loading_submit = true
            this.form.parent_id = parseInt(this.parent);
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        if (this.external) {
                            this.$eventHub.$emit('reloadDataPersons', response.data.id)
                        } else {
                            this.$eventHub.$emit('reloadData')
                        }
                        this.close()
                    } else {
                        this.$message.error(response.data.message)
                    }

                })
                .catch(error => {
                    if (error.response.status === 422) {
                        // this.errors = error.response.data
                        this.errores = error.response.data
                        let message = ''
                        Object.keys(this.errores).forEach((key) => {
                            message += `${this.errores[key][0]}<br>`
                        })
                        if (message) {
                            this.$message({
                                dangerouslyUseHTMLString: true,
                                message: message,
                                type: 'warning'
                            })
                            // this.initForm()
                        }
                    } else {
                        console.log(error)
                    }
                })
                .finally(() => {
                    this.loading_submit = false
                })
        },
        changeIdentityDocType() {
            (this.recordId == null) ? this.setDataDefaultCustomer() : null
        },
        setDataDefaultCustomer() {

            if (this.form.identity_document_type_id == '0') {
                this.form.number = '99999999'
                this.form.name = "Clientes - Varios"
            } else {
                this.form.number = ''
                this.form.name = null
            }

        },
        close() {
            this.$eventHub.$emit('initInputPerson')
            this.$emit('update:showDialog', false)
            this.initForm()
        },
        searchCustomer() {
            this.searchServiceNumberByType()
        },
        searchNumber(data) {
            //cambios apiperu
            this.form.name = data.name;
            this.form.trade_name = data.trade_name;
            this.form.location_id = data.location_id;
            this.form.address = data.address;
            // this.form.department_id = data.department_id;
            // this.form.department_id = data.department_id;
            // this.form.province_id = data.province_id;
            // this.form.district_id = data.district_id;
            this.form.condition = data.condition;
            this.form.state = data.state;
            // this.filterProvinces()
            // this.filterDistricts()
//                this.form.addresses[0].telephone = data.telefono;

            if (this.form.identity_document_type_id === '6') {
                if (this.form.state !== 'ACTIVO' && this.form.condition === 'HABIDO') {
                    this.$message.error('El estado del contribuyente no es activo')
                }
                if (this.form.condition !== 'HABIDO' && this.form.state === 'ACTIVO') {
                    this.$message.error('La condicion del contribuyente no es habido')
                }
                if (this.form.state !== 'ACTIVO' && this.form.condition !== 'HABIDO') {
                    this.$message.error('El estado del contribuyente no es activo y la condicion del contribuyente no es habido')
                }
            }
        },
        clickRemoveAddress(index) {
            // this.form.addresses.splice(index, 1);
            this.form.secondary_addresses.splice(index, 1);
        },

        saveZone() {
            this.form_zone.add = false

            this.$http.post(`/zones`, this.form_zone)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.zones.push(response.data.data)
                        this.form_zone.name = null

                    } else {
                        this.$message.error('No se guardaron los cambios')
                    }
                })
                .catch(error => {

                })


        },


    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/persons/form.vue